<template>
  <b-container>
    <b-breadcrumb>
      <b-breadcrumb-item to="/admin">Admin</b-breadcrumb-item>
      <b-breadcrumb-item active>Reviews</b-breadcrumb-item>
    </b-breadcrumb>
    <h1>All Reviews</h1>
    <reviews-table :count="25" pagination />
  </b-container>
</template>

<script>
import ReviewsTable from '@/components/admin/ReviewsTable'

export default {
  name: 'Reviews',
  components: {
    ReviewsTable
  }
}
</script>
